import { lg, xl } from '#shared/styles/breakpoints';

export const ARTICLE_MODULE_MEDIA_IMAGE_SIZES = `(max-width: ${lg}px) 100vw, (max-width: ${xl}px) 52vw, 800px`;
